// extracted by mini-css-extract-plugin
export var label = "_e5-5";
export var slideContainer = "_e5-0";
export var slider = "_e5-1";
export var sliderLg = "_e5-4";
export var sliderMd = "_e5-3";
export var sliderSm = "_e5-2";